import React, { memo } from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { useMessage } from 'modules/intl';
import PieChart from './PieChart';
import LabelChartSkeleton from './LabelChartSkeleton';
import { LabelNoData } from './LabelNoData';
import { PieChartData } from './utils';
import { useLabelStyles } from './hooks/useLabelStyles';

type TaskComponentProps = {
  data: PieChartData;
  loading: boolean;
  isEmpty: boolean;
  setGetCurrentPage?: React.Dispatch<React.SetStateAction<number>> | undefined;
};

export const TaskComponent: React.FC<TaskComponentProps> = ({
  data,
  loading,
  isEmpty,
  setGetCurrentPage
}: TaskComponentProps) => {
  const classes = useLabelStyles();
  const name = useMessage('insights.timeSheetLabels.tasks');

  return (
    <Paper
      elevation={3}
      data-testid={'source-by-task-chart-container'}
      className={classes.container}
      tabIndex={0}
    >
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography
            className={classes.typography}
            variant="h6"
            data-testid="task-chart-title"
          >
            {name}
          </Typography>
        </Grid>
        <Grid item>
          {loading ? (
            <LabelChartSkeleton />
          ) : isEmpty ? (
            <LabelNoData />
          ) : (
            <PieChart
              data={data}
              labelType="TASK"
              setGetCurrentPage={setGetCurrentPage}
            />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};
export default memo(TaskComponent);
